import React, {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {adminHttp} from "~/Admin/services/http";
import {connect} from "react-redux";
import ValidationError from "~/Components/Forms/ValidationError";
import {DeleteIcon, DownloadIcon, EditIcon} from "~/Components/Icons/Icons";
import AdminItineraryFileUploader from "~/Admin/AdminEvent/AdminEventItinerary/AdminItineraryFileUploader";
import {humanFileSize} from "~/helpers/utils";
import Moment from "react-moment";
import ConfirmedLink from "~/Components/ConfirmedButton/ConfirmedLink";

const AdminAddItinerary = ({event, children, onChange, itinerary, ...rest}) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);
    const [waves, setWaves] = useState([]);
    const [packages, setPackages] = useState([]);

    const [form, setForm] = useState({
        package_id: itinerary ? itinerary.package_id : null,
        wave_id: itinerary ? itinerary.wave_id : null,
        document_name: itinerary ? itinerary.document_name : null,
        document_link: itinerary ? itinerary.document_link : null,
    });

    const loadWaves = (page = 1) => {
        adminHttp
            .get('/events/' + event.id + '/waves',)
            .then(res => setWaves(res.data));
    };

    const loadPackages = (page = 1) => {
        adminHttp
            .get('/events/' + event.id + '/packages',)
            .then(res => setPackages(res.data));
    };

    useEffect(loadWaves, []);
    useEffect(loadPackages, []);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleChange = (e) => {

        const name = e.target.name;
        const value = e.target.value;

        let formData = {...form, [name]: value};

        setForm(formData);
    };

    const handleSubmit = () => {
        if (itinerary) {
            adminHttp
                .put('/events/' + event.id + '/itineraries/' + itinerary.id, form)
                .then(res => {
                    setError(null);
                    setShow(false);
                    onChange();
                }).catch((error) => {
                setError(error.response?.data);
            });
        } else {
            adminHttp
                .post('/events/' + event.id + '/itineraries', form)
                .then(res => {
                    setError(null);
                    setShow(false);
                    onChange();
                }).catch((error) => {
                setError(error.response?.data);
            });
        }

    };

    const handleDeleteDocument = (id) => {
        adminHttp
            .delete('/events/' + event.id + '/itineraries/' + itinerary.id + '/documents/' + id)
            .then(res => onChange());
    };

    return (
        <>
            {itinerary
                ?
                <EditIcon onClick={handleShow} />
                :
                <button {...rest} onClick={handleShow}>{children}</button>

            }

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Itinerary</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving Itineraries!"}
                        </div>
                    )}

                    <div className="form-group required">
                        <label>Wave</label>

                        <select name="wave_id"
                                defaultValue={form.wave_id}
                                onChange={e => handleChange(e)}
                                disabled={!!itinerary}
                                className="form-control">

                            <option value={0}>- Select -</option>

                            {waves.map(wave => (
                                <option key={wave.id} value={wave.id}>{wave.name}</option>
                            ))}
                        </select>

                        <ValidationError errors={error?.errors} name="wave_id"/>

                    </div>

                    <div className="form-group required">
                        <label>Package</label>

                        <select name="package_id"
                                defaultValue={form.package_id}
                                onChange={e => handleChange(e)}
                                disabled={!!itinerary}
                                className="form-control">

                            <option value={0}>- Select -</option>

                            {packages.map(p => (
                                <option key={p.id} value={p.id}>{p.name}</option>
                            ))}
                        </select>

                        <ValidationError errors={error?.errors} name="package_id"/>

                    </div>

                    {itinerary && itinerary.document && (
                        <>
                            <table style={{width: '100%'}}>
                                <tr className="font-weight-500">
                                    <td>{itinerary.document.name}</td>
                                    <td>{humanFileSize(itinerary.document.size)}</td>
                                    <td>
                                        <a className="d-inline cursor-pointer" href={itinerary.document.download_url}>
                                            <DownloadIcon classes="d-inline" />
                                        </a>
                                        <ConfirmedLink className="d-inline cursor-pointer" onClick={(e) => handleDeleteDocument(itinerary.document.id)}>
                                            <DeleteIcon classes="d-inline" />
                                        </ConfirmedLink>
                                    </td>
                                </tr>
                            </table>
                            <br/>
                        </>
                    )}
                    {itinerary && (
                        <div className="form-group itinerary">
                            <h3 className="mb-2">File Upload</h3>
                            <p className="mb-4">Upload your itinerary document</p>
                            <AdminItineraryFileUploader itinerary={itinerary} onUploaded={onChange}/>
                        </div>
                    )}


                </Modal.Body>
                {!itinerary &&
                    <Modal.Footer>
                        <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                            Cancel
                        </button>
                        <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                            Save
                        </button>
                    </Modal.Footer>
                }
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminAddItinerary);
